import client from "./client";

const getCustomers = () => client.get("customer/all/paginated");

export default { getCustomers };
